import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import DefaultLayout from '../../layouts/Default'
import { useDevice } from '../../hook/useDevice'
import LabshighMobileComponent from './components/labshigh/LabshighMobile'
import LabshighPCComponent from './components/labshigh/LabshighPC'
import OverviewPCComponent from './components/overview/OverviewPC'
import OverviewMobileComponent from './components/overview/OverviewMobile'
import EcosystemPCComponent from './components/ecosystem/EcosystemPC'
import EcosystemMobileComponent from './components/ecosystem/EcosystemMobile'
import TeamMobileComponent from './components/team/TeamMobile'
import TeamPCComponent from './components/team/TeamPC'
import ContactMobileComponent from './components/contact/ContactMobile'
import ContactPCComponent from './components/contact/ContactPC'
import MainnetComponent from './components/mainnet/MainnetPC'
import MainnetMobileComponent from './components/mainnet/MainnetMobile'
import ServicePCComponent from './components/service/ServicePC'
import ServiceMobileComponent from './components/service/ServiceMobile'

const Home: React.FC<any> = () => {
  const { isMobile } = useDevice()
  const location = useLocation()
  const Labshigh = useMemo(() => (isMobile ? <LabshighMobileComponent /> : <LabshighPCComponent />), [isMobile])
  const Overview = useMemo(() => (isMobile ? <OverviewMobileComponent /> : <OverviewPCComponent />), [isMobile])
  const Ecosystem = useMemo(() => (isMobile ? <EcosystemMobileComponent /> : <EcosystemPCComponent />), [isMobile])
  const Service = useMemo(() => (isMobile ? <ServiceMobileComponent /> : <ServicePCComponent />), [isMobile])
  const Team = useMemo(() => (isMobile ? <TeamMobileComponent /> : <TeamPCComponent />), [isMobile])
  const Contact = useMemo(() => (isMobile ? <ContactMobileComponent /> : <ContactPCComponent />), [isMobile])
  const Mainnet = useMemo(() => (isMobile ? <MainnetMobileComponent /> : <MainnetComponent />), [isMobile])

  const moveToScroll = () => {
    const targetEl = document.getElementById(location.hash.split('#')[1])
    console.log(targetEl?.offsetTop, 'targetEl?.offsetTop')
    targetEl?.offsetTop && window.scrollTo(0, targetEl?.offsetTop)
  }

  // location.hash ===

  React.useEffect(() => {
    setTimeout(() => {
      location.hash && moveToScroll()
    }, 200)
  }, [])

  return (
    <DefaultLayout>
      <Wrap>
        <Section id={'mverse'}>{Labshigh}</Section>
        <Section id={'overview'}>{Overview}</Section>
        <Section id={'ecosystem'}>{Ecosystem}</Section>
        <Section id={'service'}>{Service}</Section>
        <Section id={'download'}>{Mainnet}</Section>
        <Section id={'team'} style={{ zIndex: 10 }}>
          {Team}
        </Section>
        {/* Contact + Footer */}
        <Section id={'contact'}>{Contact}</Section>
      </Wrap>
    </DefaultLayout>
  )
}

export default Home

const Wrap = styled.div`
  #labshigh {
    z-index: 20;
  }
`

const Section = styled.div`
  position: relative;
`
